import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { WORKER_TYPE_FAQ } from '../constants';

const renderAnswer = (answer: string) =>
  answer.split('\n\n').map((paragraph, i) => (
    <Typography
      key={i}
      variant="body1"
      color={colors.neutral[600]}
      style={{
        marginTop: i === 0 ? 0 : 12,
        lineHeight: 1.5,
        whiteSpace: 'pre-line',
        marginBottom: 0,
      }}
    >
      {paragraph}
    </Typography>
  ));

export const FaqSection = () => (
  <Box pt={8}>
    <Typography variant="h5"
      as="h2"
     
      color={colors.neutral[600]}
      style={{ margin: 0, marginBottom: 24 }}
    >
      Frequently Asked Questions
    </Typography>
    <Box
      style={{
        backgroundColor: colors.shades[0],
        border: `1.5px solid ${colors.neutral[100]}`,
        borderRadius: 8,
        overflow: 'hidden',
      }}
    >
      {WORKER_TYPE_FAQ.map(({ value, question, answer }) => (
        <Accordion key={value}>
          <AccordionSummary>{question}</AccordionSummary>
          <AccordionDetails>
            {typeof answer === 'string' ? renderAnswer(answer) : answer}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  </Box>
);
